export function createChartingFilterOptions(definition = {}) {
    return {
        currencies: definition?.availableCurrencies || [],
        countries: definition?.availableCountries || [],
        sectors: definition?.availableSectors || [],
        industries: definition?.availableIndustries || []
    };
}

export function createChartingFilterAccessState(permissions = {}) {
    const normalizedPermissions = permissions && typeof permissions === 'object' ? permissions : {};
    const canFilterBySector = Boolean(normalizedPermissions?.sector_filter);

    return {
        amount: Boolean(normalizedPermissions?.amount_filter),
        entryDistance: Boolean(normalizedPermissions?.entry_distance_filter),
        age: Boolean(normalizedPermissions?.years_filter),
        dividends: Boolean(normalizedPermissions?.dividends_filter),
        currency: Boolean(normalizedPermissions?.currency_filter),
        country: Boolean(normalizedPermissions?.country_filter),
        sector: canFilterBySector,
        industry: Boolean(normalizedPermissions?.industry_filter) || canFilterBySector
    };
}
